let QRCode = require('exports-loader?QRCode!qrcodejs/qrcode.min')

angular.module('eatself').component('qrcode',{
	bindings: {
		size: '@',
		data: '@',
	},
	controllerAs: 'vm',
	controller: angular.module('eatself').classy.controller({
		inject: ['$scope','$timeout'],
		methods: {
			$onInit() {
				this.$timeout(()=>{
					this.qrcode = new QRCode('qrcode-'+this.$scope.$id, {
						text: this.data,
						width: this.size,
						height: this.size,
						colorDark : "#000000",
						colorLight : "#ffffff",
						correctLevel : QRCode.CorrectLevel.H,
					});
				});
			},
			$onChanges() {
				if (this.qrcode) {
					this.qrcode.clear();
					this.qrcode.makeCode(this.data);
				}
			}

		}
	}),
	template: `
	<div id="qrcode-{{$id}}"></div>
	`,
})